import { render, staticRenderFns } from "./Yongren.vue?vue&type=template&id=656974bd&scoped=true&"
import script from "./Yongren.vue?vue&type=script&lang=js&"
export * from "./Yongren.vue?vue&type=script&lang=js&"
import style0 from "./Yongren.vue?vue&type=style&index=0&id=656974bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656974bd",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection})
